import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface PageLoaderProps {
  size?: 'sm' | 'md' | 'lg';
  heightClassName?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({
  size = 'lg',
  heightClassName = 'h-64'
}) => {
  return (
    <div className={`flex items-center justify-center ${heightClassName}`}>
      <LoadingSpinner size={size} />
    </div>
  );
};

export default PageLoader;
